import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { StyledButton } from "../../../components/ListShowButton";

interface IRejectButton {
  id: number;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
});

const CustomConfirmButton = ({ id }: IRejectButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleReject, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `subcontractorPurchaseInvoices/${id}/reject`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully reject purchase invoice.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed reject purchase invoice, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleReject}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const RejectButton = ({ id }: IRejectButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <StyledButton
        variant="outlined"
        onClick={handleOpenDialog}
        style={{ color: "#f44336", borderColor: "#f44336" }}
      >
        Reject
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Reject The Purchase Invoice
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to reject the purchase invoice?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton id={id} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default RejectButton;
